<div class="time mat-headline-{{ size }}">{{ time$ | async }}</div>
